export default __webpack_public_path__ + "static/char-s-10-kr-e086deb15cc48e8e7cbfc9908871a89c.png";